<template>
  <b-row>
    <b-col sm="12" lg="12">
      <b-card class="lineClass">
        <div
          slot="header"
          style="display:flex; justify-content: space-between;"
        >
          <HeaderTitle title="Region Overview"></HeaderTitle>
          <HeaderControl
            :showFullscreenIcon="true"
            @emit-fullscreen="toggleFullScreenLine"
          ></HeaderControl>
        </div>
        <LoadingCard v-if="loadingState"></LoadingCard>
        <GChart
          v-if="!loadingState"
          :settings="{
            packages: ['geochart'],
            mapsApiKey: googleMapsApi
          }"
          type="GeoChart"
          :data="chartData1"
          :options="chartOptions"
          :events="chartEvents"
          style
          ref="gChart"
          class="themap"
        />
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { GChart } from "vue-google-charts";
import Datepicker from "vuejs-datepicker";
import { MapByStateChart } from "../../../utils/ChartProps";
import HeaderControl from "../../../components/shared/HeaderControl.vue";
import HeaderTitle from "../../../components/shared/HeaderTitle.vue";
import LoadingCard from "../../../components/shared/LoadingCard.vue";
import { from, to } from "../../../utils/Utils";
import router from "../../../router";
export default {
  props: ["state", "date_from", "date_to", "locations"],
  name: "MapByState",
  components: {
    GChart,
    router,
    Datepicker,
    HeaderControl,
    HeaderTitle,
    LoadingCard
  },
  data() {
    return {
      from: from,
      to: to,
      googleMapsApi: process.env.VUE_APP_GOOGLE_MAPS_API,
      loadingState: true,
      chartData: [],
      chartData1: [],
      chartOptions: {},
      chartEvents: {
        select: () => {
          const selection = this.$refs.gChart.chartObject;
          var selectedItem = selection.getSelection()[0];
          var topping = this.chartData[selectedItem.row + 1];
          var splitting = topping[2].split("#");
          var id = splitting[1];
          var city = topping[0];
          var lat = splitting[2];
          var lng = splitting[3];
          router.push(
            "/base/CityDashboard/?loc=" +
              id +
              "&city=" +
              city +
              "&lat=" +
              lat +
              "&lng=" +
              lng
          );
        }
      }
    };
  },
  methods: {
    fetchCityReport() {
      this.loadingState = true;
      let params = {};
      params = {
        locations: this.locations,
        state: this.state,
        date_from: from(this.date_from),
        date_to: to(this.date_to)
      };
      this.$http.get("api/maps/mapByState.php", { params }).then(
        res => {
          this.loadingState = false;
          this.chartData = res.data.records;
          var myFix = { type: "string", role: "tooltip", p: { html: true } };
          this.chartData[0][2] = myFix;
          for (let i = 1; i < this.chartData.length; i++) {
            var prvi = this.chartData[i][0].split("#");
            this.chartData[i][0] = prvi[0];
            this.chartData[i][2] =
              "<div style='width:130px'><span>Quantitiy: " +
              this.chartData[i][1] +
              "</span><br>" +
              "<span>$" +
              this.chartData[i][2].toFixed(2) +
              "</span><br></div><div style='display:none'>#" +
              prvi[1] +
              "#" +
              prvi[2] +
              "#" +
              prvi[3] +
              "#</div>";
          }
          this.loadingState = false;
          this.chartData1 = this.chartData;
        },
        err => {
          console.log(err);
          this.loadingState = false;
        }
      );
    },
    toggleFullScreenLine() {
      this.$fullscreen.toggle(this.$el.querySelector(".lineClass"), {
        wrap: false,
        callback: this.fullscreenChangeLine
      });
    }
  },
  mounted() {
    this.chartOptions.region = "US-" + this.state;
    this.fetchCityReport();
  },
  beforeMount() {
    this.chartOptions = MapByStateChart();
  }
};
</script>
